import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ImageAssetUploadProvider } from "@staylayer/puck-components";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from "./auth/AuthProvider";
import { ToastProvider } from "./components/ToastProvider";
import { router } from "./routes";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { OnboardingMentorProvider } from "./onboarding";
import { dashboardImageAssetUploader } from "./lib/image-asset-upload";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const analyticsMode = import.meta.env.PROD ? "production" : "development";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ImageAssetUploadProvider uploader={dashboardImageAssetUploader}>
          <OnboardingMentorProvider>
            <ErrorBoundary>
              <RouterProvider router={router} />
            </ErrorBoundary>
            <ToastProvider />
            <SpeedInsights />
            <Analytics mode={analyticsMode} />
          </OnboardingMentorProvider>
        </ImageAssetUploadProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
